import React from 'react'
import { OutboundLink } from 'react-ga'

const ItemCardFeature = ({ dataIndex, item }) => {
  return (
    <OutboundLink
      className="cardLink cardLink__foty_redesign"
      data-index={dataIndex.index}
      data-index-column={dataIndex.indexColumn}
      data-index-row={dataIndex.indexRow}
      data-rank={dataIndex.displayOrder}
      id={`card-${item.displayOrder}--fc`}
      key={`feature--nextToRank--${item.displayOrder}`}
      to={item.feature.frontmatter.linkExternal}
      eventLabel={item.feature.frontmatter.linkExternal}
      rel="noopenner noreferrer"
      target="_blank"
    >
      <article className="card featureCard">
        <div className="featureWrapper">
          <h4 className="featureTitle">{item.feature.frontmatter.title}</h4>
          <span className="featureAuthor">
            {item.feature.frontmatter.byLine}
          </span>
          <div
            className="featureContent"
            dangerouslySetInnerHTML={{ __html: item.feature.html }}
          />
          <span className="featureBrand">
            {item.feature.frontmatter.linkAttribution}
          </span>
        </div>
      </article>
    </OutboundLink>
  )
}

export default ItemCardFeature
